import React, {Component} from 'react';
import {Navbar, Grid, Row, Col} from 'react-bootstrap';
import './App.css';
import FlircConfig from './FlircConfig';
import FadingAlert from './FadingAlert';
import {filter as _filter, concat as _concat, map as _map} from 'lodash';

class App extends Component {
    constructor(props) {
        super(props);
        this.alertCounter = 0;
        this.state = {
            alerts: [],
        };
    }

    addAlert = (message, style) => {
        let alertIdx = this.alertCounter++;
        let alert = [alertIdx, message, style];
        this.setState({
            alerts: _concat(this.state.alerts, [alert]),
        });
    };

    handleAlertDismiss = (idx) => {
        this.setState({
            alerts: _filter(this.state.alerts, (item) => {
                return item[0] !== idx;
            }),
        });
    };

    handleFileLoaded = (loadedFile) => {
        this.addAlert("File " + loadedFile.name + " has been loaded successfully.", "success");
    };

    handleFileError = (errorMsg) => {
        this.addAlert(errorMsg, "danger");
    };

    render() {
        return (
            <div>
                <Navbar>
                    <Navbar.Header>
                        <Navbar.Brand>Flirc</Navbar.Brand>
                    </Navbar.Header>
                </Navbar>
                <Grid>
                    <Row className='alerts-container'>
                        <Col className='alerts' xs={12} sm={6} smPush={6} md={5} mdPush={7}>
                            {_map(this.state.alerts, ([idx, message, style]) => {
                                return (
                                    <FadingAlert key={idx.toString()} bsStyle={style} onExited={() => { this.handleAlertDismiss(idx) }} alertTimeout={5000}>{message}</FadingAlert>
                                );
                            })}
                        </Col>
                    </Row>
                    <FlircConfig onSuccess={this.handleFileLoaded} onError={this.handleFileError} />
                </Grid>
            </div>
        )
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js